<!--
  File name: TermsSignup.vue
  Program Description:
    - This component displays the terms and conditions the user needs to accept
    upon signup.

-->

<template>
  <v-container class="pa-0 pb-5  justify-center mt-n5 ma-0">
    <v-row class="ma-0 d-flex justify-center">
      <v-row class="pt-6 pb-8">
        <v-col
          class="pa-0 d-flex justify-end"
          cols="1"
        >
          <v-checkbox
            v-model="termsandconditions"
            disabled
            class="pa-0"
            @change="$emit('change', termsandconditions)"
          />
        </v-col>
        <v-col class="pa-0 pr-6 mt-4">
          <p
            style="font-size: 14px; text-align:center; height: 10px;"
          >
            To create an account and agree to the processing of your personal
            information, please click our
            <span
              class="primary--text mt-n4 justify-center font-weight-black"
              style="font-size:14px; cursor: pointer;"
              @click="dialog = true"
            >
              Terms and Conditions / Privacy
              Notice
            </span>
          </p>
        </v-col>
      </v-row>

      <v-dialog
        v-model="dialog"
        max-width="800px"
        persistent
      >
        <v-card
          class="elevation-12 px-5 pt-6 pb-11 rounded-lg"
          tile
        >
          <v-row class="pb-7">
            <v-spacer />
            <v-icon
              v-if="openNotice || openTerms"
              id="close-terms-button"
              class=" closeBtn align-right text--darken-5"
              @click="openNotice = false, openTerms = false"
            >
              mdi-close
            </v-icon>
          </v-row>
          <v-divider v-if="openNotice || openTerms" />
          <v-card-title
            class="title justify-center"
          >
            <h1
              class="primary--text text-h3 font-weight-bold"
            >
              {{ title }}
            </h1>
          </v-card-title>
          <v-card-text
            v-if="!openNotice && !openTerms"
            class="mt-4"
          >
            <p class="black--text">
              The National Privacy Commission (NPC) is mandated by the Sec.38 of the Implementing Rules and Regulations (IRR) of R.A. 10173 (DPA of 2012) to be notified by the personal information controller (PIC) or personal information processor (PIP) when there is reasonable belief that a personal data breach occurred. The Data Breach Notification Management System (DBNMS) is a digital platform that allows PICs and PIPs to submit their report to the NPC. It requires users to provide personal information such as full name, sex, email and contact number. All personal data is collected through the web forms and files uploaded within the DBNMS. The personal data that will be processed by the DBNMS will be within the custody of the NPC and will be shared with relevant government agencies as required following relevant laws and shall follow the requirements of the DPA of 2012 its IRR and other issuances of NPC. All collected Personal Data will be kept in accordance with NPC’s Retention policy. Users of the DBNMS may exercise their privacy rights such as right to be informed, right to object, right to access, right to rectification, right to erasure or blocking, right to data portability, right to file a complaint and right to damages. Rest assured that all personal data will be kept in a secure and confidential manner by implementing up to data protection measures. To know more about NPC's Privacy Notice please click this <span
                class="primary--text font-weight-black"
                style="cursor: pointer"
                @click="openNotice = true"
              >link</span>
            </p>
            <v-checkbox
              v-model="checkNotice"
            >
              <template
                v-slot:label
              >
                <span style="font-size: 14px; ">
                  By ticking the checkbox, you agree with the processing of your personal information.
                </span>
              </template>
            </v-checkbox>
            <p class="black--text">
              In using the DBNMS, the users need to abide by the Terms and Conditions intended for this system. To see the full details, please click this <span
                class="primary--text font-weight-black"
                style="cursor: pointer"
                @click="openTerms = true"
              >link</span>
            </p>
            <v-checkbox
              v-model="checkTerms"
            >
              <template
                v-slot:label
              >
                <span style="font-size: 14px;">
                  By Ticking the checkbox, you agree with the Terms and Conditions
                </span>
              </template>
            </v-checkbox>
          </v-card-text>

          <v-card-text v-if="openTerms === true">
            <p class="black--text text-subtitle-2">
              Introduction
            </p>
            <p class="black--text">
              Your access to and use of the Data Breach Notification Management System (DBNMS) is conditioned on your acceptance of and compliance with these terms. These terms and conditions serve as the entire agreement between you and the National Privacy Commission in reference to your access and use of the DBNMS.
              <br> <br>
              These terms and conditions apply to all visitors, registrants, and users of the DBNMS.
              <br> <br>
              The National Privacy Commission reserves the right to modify, add to, or delete sections or portions of these terms and conditions. It is your responsibility to exercise due diligence in reviewing the same before proceeding with the DBNMS. By proceeding with the use of the system, you are thereby agreeing to any changes made in the terms and conditions prior to such access.
            </p>
            <p class="black--text text-subtitle-2">
              Use of Intellectual Property
            </p>
            <p class="black--text">
              You are not allowed to use or appropriate any design, logos, features, functionality, and other intellectual property in the system without the prior approval by the National Privacy Commission.
            </p>
            <p class="black--text text-subtitle-2">
              Acceptable Use
            </p>
            <p class="black--text">
              You shall use the DBNMS only for submission of Data Breach Notifications and Annual Security Incident Reports.
              <br> <br>
              Any activity that may cause damage to the DBNMS, or otherwise impair the availability or accessibility of the website or the system constitutes a violation of the terms and conditions. The NPC reserves the right to suspend or terminate your access to or use of the system as we may deem necessary.
            </p>
            <p class="black--text text-subtitle-2">
              Modifications and Interruptions
            </p>
            <p class="black--text">
              You shall use the DBNMS only for submission of Data Breach Notifications and Annual Security Incident Reports.
              <br> <br>
              In the unlikely case of typographical errors, inaccuracies, or inadvertent omissions, the NPC reserves the right to rectify the same, or update the information on the DBNMS at any time, without prior notice.
              <br> <br>
              We do not guarantee that the DBNMS will be available at all times.  We may experience hardware, software, or other problems or need to perform maintenance resulting in interruptions, delays, or errors.  We reserve the right to change, revise, update, suspend, discontinue, or otherwise modify the DBNMS at any time as we may deem necessary.
              <br> <br>
              You agree that we have no liability whatsoever for any loss, damage, or inconvenience caused by your inability to access or use the DBNMS during any downtime or discontinuance of the DBNMS.
            </p>
          </v-card-text>
          <v-card-text v-if="openNotice === true">
            <p class="black--text text-subtitle-2">
              Data Breach Notification Management System
            </p>
            <p class="black--text">
              The Data Breach Notification Management System (DBNMS) of the National Privacy Commission (NPC) is a system in which a Personal Information Controller (PIC) or Personal Information Processor (PIP) can submit their Data Breach Notification and Annual Security Incident Report to NPC.  Data Breach Notification is required by the NPC pursuant to the Data Privacy Act of 2012 (DPA), its Implementing Rules and Regulations (IRR), NPC Circular No. 16-03, NPC Advisory No. 2018-02, and its other relevant issuances.
            </p>
            <p class="black--text text-subtitle-2">
              Personal Data Collected
            </p>
            <p class="black--text">
              1.  Full name (Last Name, First Name, Middle Initial)<br>
              2.  Email address<br>
              3.  Telephone number/ Mobile number<br>
              4.  Sex<br>
            </p>
            <p class="black--text text-subtitle-2">
              Basis of Processing
            </p>
            <p class="black--text">
              All personal data collected thru the DBNMS will be used for the processing of Data Breach Notification Reports, Annual Security Incident Reports, and to comply with R.A. 94710 (Gender and Development of the Government). In addition, the Commission may use the personal information for any purposes deemed necessary according to its mandate.
            </p>
            <p class="black--text text-subtitle-2">
              Purpose of Personal Data Processing
            </p>
            <p class="black--text">
              The DBNMS processes personal data pursuant to NPC’s mandate under the DPA, its IRR, NPC Circular No. 2016-03, NPC Advisory No. 2018-02, and its other relevant issuances.
            </p>
            <div style="margin-left: 2rem">
              <p class="black--text text-subtitle-2">
                • How Data is collected
              </p>
              <p class="black--text">
                NPC collects personal information for account creation with the DBNMS which shall enable you to notify the NPC about personal data breaches that is required under NPC Circular No. 16-03, and to submit Annual Security Incident Reports, as required by Section20 (f) of the DPA and NPC Advisory No. 2018-02.
                While using the DBNMS, NPC may collect your gender data in compliance with the Harmonized Gender and Development Guidelines set by the National Government.
              </p>
              <p class="black--text text-subtitle-2">
                • How Data is used
              </p>
              <p class="black--text">
                The NPC will collect, store, and use personal data to accomplish the following:<br>
                • Create an account <br>
                • Communicate with the PIC, PIP, or its authorized representatives regarding the personal data breach that they have notified the NPC <br>
                • Receive and respond to any inquiries that are built-in in the User Page<br>
                • Generate statistics regarding personal data breaches and other security incidents
              </p>
              <p class="black--text text-subtitle-2">
                • Disclosure/Sharing
              </p>
              <p class="black--text">
                The Commission does not share any personal information to any third-party entities except to law enforcement partners/agencies such as the Department of Justice, etc. to enable the enforcement of the law as stated in Section 7 (i) of R.A. 10173 or the DPA of 2012
              </p>
              <p class="black--text text-subtitle-2">
                • Risks involved
              </p>
              <p class="black--text">
                The NPC recognizes the risks involved in the processing of personal data such as when systems are exposed to malware, ransomware, and computer viruses or when manual records are accessed without authority. However, the Commission undertakes to collect and process adequate, and not excessive, personal data in relation to the declared purpose. Adequate policies are also in place to ensure appropriate security incident management.
              </p>
            </div>
            <p class="black--text text-subtitle-2">
              How data is protected
            </p>
            <div style="margin-left:2rem">
              <p class="black--text text-subtitle-2">
                • Storage, Security, Disposal and Retention
              </p>
              <p class="black--text">
                The NPC safeguards the confidentiality, integrity, and availability of your personal information physically and/or electronically by maintaining a combination of organizational, physical, and technical security measures based on accepted data privacy and information security standards such as on access control, acceptable use, firewall, end-to-end encryption, data classification requirements, etc. The Commission may also store your personal information with third-party data storage providers (cloud) which shall ensure that proper measures are adopted to protect your information. Personal data shall be stored in the database for 5 years extendible as the need arises due to pendency of a case or any other legal ground. Once data has served its purpose, it shall be forwarded for archiving for 10 years in a secured physical drive before being completely disposed and destroyed.
              </p>
            </div>
            <p class="black--text text-subtitle-2">
              Methods utilized for automated access
            </p>
            <p class="black--text">
              The DBNMS uses a third-party service, which uses cookies, to analyze non-identifiable web traffic data. However, the generated data is not shared with any other party.  Only non-identifiable web traffic data are analyzed, including:<br>
              • Your IP Address <br>
              • The pages and internal links accessed on our site<br>
              • The data and time you visited the site<br>
              • Geolocation<br>
              • The referring site or platform (if any) through which you clicked on our site.<br>
              • Your operating system<br>
              •  Web browser type
            </p>
            <p class="black--text text-subtitle-2">
              Changes to the privacy notice
            </p>
            <p class="black--text">
              NPC reserves the right to update or revise this privacy notice at any time and will provide a new privacy notice whenever there are substantial changes. Previous versions of the privacy notice are retained by the Commission and shall be provided to data subjects upon request.
            </p>
            <p class="black--text text-subtitle-2">
              Rights of Data Subjects
            </p>
            <p class="black--text">
              Under the Data Privacy Act, you have the right to be informed and ask for a copy of any personal information we hold about you, as well as to dispute and have it corrected in case of inaccuracy or error in our records.
              You also have the right to suspend, withdraw or order the blocking, removal, or destruction of your personal data.
              You may claim compensation if you suffered damages due to inaccurate, incomplete, outdated, false, unlawfully obtained, or unauthorized use of personal data, considering any violation of your rights and freedoms as data subject.
              If you feel that your personal information has been misused, maliciously disclosed, or improperly disposed, or that any of your data privacy rights have been violated, you have a right to file a complaint with the NPC.
              You also have the right to dispute and have corrected any inaccuracy or error in the data a personal information controller (PIC) holds about you.
              Should you wish to exercise these rights, please contact our Data Protection Officer through any of the details provided below.
            </p>
            <div style="margin-left:2rem">
              <p class="black--text text-subtitle-2">
                • How to file a complaint
              </p>
              <p class="black--text">
                If there is a complaint regarding the processing of personal data, please contact the Data Protection Officer listed below.  It is the right of the Data Subject to lodge a complaint with the National Privacy Commission to protect its personal information.
              </p>
            </div>
            <p class="black--text text-subtitle-2">
              Data Protection Officer Contact Details
            </p>
            <p class="black--text">
              If you have any questions regarding the DBNMS, you may contact the National Privacy Commission through our Data Protection Officer with the contact details listed below:
            </p>
            <p class="black--text">
              Name: <b>Atty. Ivin Ronald D.M. Alzona </b><br>
              Tel.no: <b>82342228</b>  <br>
              Email: <b>dpo@privacy.gov.ph</b> <br>
              Address: <b>5th Floor, Delegation Building, PICC Complex, Vicente Sotto Ave., Pasay City, 1308</b> <br>
            </p>
            <p class="black--text">
              Date of effectivity: <b>4/20/2022</b><br>
            </p>
          </v-card-text>
          <v-btn
            v-if="openNotice || openTerms"
            text
            @click="openNotice = false, openTerms = false"
          >
            <v-icon>mdi-arrow-left-thin</v-icon> Back
          </v-btn>
          <v-card-actions
            v-if="!openNotice && !openTerms"
            class="justify-right"
          >
            <v-spacer />
            <v-btn
              class="white--text "
              color="#e9c034"
              :disabled="!outerCheckbox"
              @click="dialog = false"
            >
              Continue
              <v-icon>mdi-arrow-right</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <slot name="action" />
  </v-container>
</template>

<script>
export default {
  name: 'PrivacyAndTerms',
  props: {

  },
  data: function () {
    return {
      dialog: true,
      openNotice: false,
      openTerms: false,
      checkNotice: false,
      checkTerms: false,
      termsandconditions: false
    }
  },
  computed: {
    title () {
      if (this.openTerms) {
        return 'Terms and Conditions'
      } else {
        return this.openNotice ? 'Privacy Notice' : 'Privacy Statement'
      }
    },
    outerCheckbox () {
      return this.checkNotice && this.checkTerms
    }
  },
  watch: {
    outerCheckbox () {
      if (!this.checkNotice || !this.checkTerms) this.termsandconditions = false
      if (this.checkNotice & this.checkTerms) this.termsandconditions = true
    },
    termsandconditions: function () {
      this.$emit('change', this.termsandconditions)
    }
  }

}
</script>

<style scoped>
 .v-btn{
    text-transform: none;
  }

</style>
